
import { MessageBox } from 'element-ui';


export default {

    headers:{
        token: sessionStorage.getItem("sys-token"),
        userId: sessionStorage.getItem("loginUser")!==null?JSON.parse(sessionStorage.getItem("loginUser")).id:''
    },

    onChange: function(file,fileList){
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (extension !== 'xlsx' && extension !== 'xls') {
            MessageBox.alert('只能上传Excel的文件')
            return false
        }
    },
    onExcced: function (files,fileList) {
        MessageBox.alert(`只能选择 ${files.length} 个文件`,'失败')
        return false
    },
    onError: function (err, file, fileList) {
        MessageBox.alert('文件上传失败：'+err)
        return false
    },
    beforeUpload: function (file) {
        let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (extension !== 'xlsx' && extension !== 'xls') {
            MessageBox.alert('只能上传Excel的文件','失败')
            return false
        }
        const isLt1M = file.size / 1024 / 1024 > 1
        if (isLt1M) {
            MessageBox.alert('上传导卡数据大小不能超过 1MB!')
            return false
        }
        return true
    }

}

